import { render } from "./DesktopMenu.vue?vue&type=template&id=45ba4d0a&scoped=true"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"

import "./DesktopMenu.vue?vue&type=style&index=0&id=45ba4d0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ba4d0a"]])

export default __exports__